import { render } from "./Medications.vue?vue&type=template&id=064a9674&scoped=true"
import script from "./Medications.vue?vue&type=script&lang=js"
export * from "./Medications.vue?vue&type=script&lang=js"

import "./Medications.vue?vue&type=style&index=0&id=064a9674&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064a9674"]])

export default __exports__